import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { CheckInPermissions, ProjectCheckIn } from "../api/dto/ProjectCheckIn";
import {
  CheckInSettingsFields,
  isValidGrantHours,
} from "../components/companies/CheckInSettingsFields";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const EditCheckInModal: FC<{ checkIn: ProjectCheckIn; projectName: string }> = (props) => {
  const { updateCheckIn } = useApiCall();
  const refresh = useRefresh();
  const [grantHours, setGrantHours] = useState<number>(props.checkIn.grantHours);
  const [permissions, setPermissions] = useState<CheckInPermissions>(props.checkIn.permissions);
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    setErrors([]);
    await updateCheckIn(props.checkIn.uuid, permissions, grantHours).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };

  return (
    <div className={"flex-col space-y-3"}>
      <p className={"text-sm text-slate-600"}>
        Check-in voor <strong>{props.projectName}</strong>. De wijzigingen gelden alleen voor
        bezoekers die daarna inchecken; wie al is ingecheckt houdt de eerder gekozen rechten. Je
        kunt niet meer rechten meegeven dan je zelf hebt.
      </p>
      <CheckInSettingsFields
        grantHours={grantHours}
        onGrantHoursChange={setGrantHours}
        permissions={permissions}
        onPermissionsChange={setPermissions}
        errors={errors}
      />
      <ModalFooter text={"Opslaan"} disabled={!isValidGrantHours(grantHours)} onSubmit={save} />
    </div>
  );
};
